import React from "react";
import { useUserContext } from "context/UserContext";
import DeviceInfoBK from "layouts/BK/deviceInfo";
import { normalizeRoleLevel } from "utils/roleUtils";

function BatteryInfos() {
  const { roleLevel } = useUserContext() || {};
  if (normalizeRoleLevel(roleLevel)) {
    return <DeviceInfoBK />;
  }
  return null;
}

export default BatteryInfos;
